var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('echarts-chart',{attrs:{"width":`100%`,"height":`500px`,"chart-option":_vm.chartOption}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }